import { Component, ViewEncapsulation, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'inactive-user',
    templateUrl: 'inactive.user.component.html',
    styleUrls: ['inactive.user.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class InactiveUserComponent {

    @HostBinding('class.modern-form') modern = true;
}
